import React from "react";
import { Droplets, Gauge, Syringe, Container, Activity, MonitorDot } from "lucide-react";
import { cn } from "@/lib/utils";

const NODES = [
  { key: "reservoir", label: "Reservoir", icon: Droplets },
  { key: "pump", label: "Pompa", icon: Gauge },
  { key: "injector", label: "Injektor", icon: Syringe },
  { key: "column", label: "Kolom", icon: Container },
  { key: "detector", label: "Detektor", icon: Activity },
  { key: "computer", label: "Komputer", icon: MonitorDot },
];

export default function FlowDiagram({ active = false }) {
  return (
    <div className="instrument-surface rounded-md p-4 overflow-x-auto" data-testid="flow-diagram">
      <div className="flex items-center gap-1 min-w-[640px]">
        {NODES.map((n, i) => (
          <React.Fragment key={n.key}>
            <div className="flex flex-col items-center gap-2 flex-1">
              <div
                className={cn(
                  "h-12 w-12 rounded-md flex items-center justify-center border transition-colors duration-300",
                  active
                    ? "border-[#16A34A] bg-[#16A34A]/15 text-[#22c55e] node-active"
                    : "border-[#27272a] bg-[#18181b] text-[#a1a1aa]"
                )}
              >
                <n.icon className="h-5 w-5" />
              </div>
              <span className={cn("text-[11px] font-data", active ? "text-[#d4d4d8]" : "text-[#71717a]")}>
                {n.label}
              </span>
            </div>
            {i < NODES.length - 1 && (
              <div
                className={cn(
                  "h-[2px] w-6 sm:w-10 flex-shrink-0 mb-5 transition-colors duration-300",
                  active ? "bg-[#16A34A]" : "bg-[#27272a]"
                )}
              />
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
}
